/**
 * Confirms the current login: the first authenticated request carrying the
 * token's loginLogId marks the login row confirmed, giving it session
 * authority. Posts to ANALYTICS_API_URL, which the env block fills from
 * IMPORTSCAN_AWS_URL when it is unset. Lighthouse calls no other
 * session-checked endpoint, so without this ping a login used only here
 * would stay unconfirmed. Fire-and-forget: the response is ignored and
 * errors are swallowed, so a wrong host leaves the login unconfirmed
 * silently.
 */
export default function confirmLogin({ $axios, $auth }) {
  if (!$auth || !$auth.loggedIn || !process.env.ANALYTICS_API_URL) {
    return
  }

  $axios
    .post(
      `${process.env.ANALYTICS_API_URL}/check/page-view`,
      {},
      { progress: false }
    )
    .catch(() => {})
}
